module.exports = "Hi, thanks for coming, etc.\n\nSo this is going to b a *brief* introduction to React.\n\n- heard of / used React\n\nBetter understanding of\n- What React is\n- Where it came from\n- The benefits and why we use it\n\n- coding examples. \n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/01_intro/notes_1.md
// module id = 1444
// module chunks = 0